import { ptBrCommonFieldsTranslations } from "../common";

export const company = {
  name: "Empresa |||| Empresas",
  fields: {
    name: "Nome",
    cnpj: "CNPJ",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
    updatedAt: ptBrCommonFieldsTranslations.updatedAt,
  },
};
